import React from "react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-gray-800 pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 text-sm">
        {/* SERVICES */}
        <div>
          <h3 className="font-semibold mb-3">SERVICES</h3>
          <ul className="space-y-2">
            <li>Talent on Demand</li>
            <li>Workforce Solutions</li>
            <li>Digital Transformation</li>
            <li>Analytics</li>
          </ul>
        </div>

        {/* PRODUCTS */}
        <div>
          <h3 className="font-semibold mb-3">PRODUCTS</h3>
          <ul className="space-y-2">
            <li>RecordsMine</li>
            <li>Artemis</li>
            <li>PRESS</li>
            <li>Online Assessment Appeals</li>
            <li>Tax Portal</li>
            <li>Meeting Manager</li>
            <li>Document Summary Management System</li>
          </ul>
        </div>

        {/* INDUSTRIES */}
        <div>
          <h3 className="font-semibold mb-3">INDUSTRIES</h3>
          <ul className="space-y-2">
            <li>Pharma & Healthcare</li>
            <li>BFSI</li>
            <li>Media & Creatives</li>
            <li>Telecom</li>
            <li>Manufacturing</li>
            <li>Retail</li>
            <li>E-Government</li>
          </ul>
        </div>

        {/* ABOUT US */}
        <div>
          <h3 className="font-semibold mb-3">ABOUT US</h3>
          <ul className="space-y-2">
            <li>Company</li>
            <li>News</li>
            <li>Awards</li>
            <li>Downloads</li>
            <li>Employee Support</li>
          </ul>
        </div>

        {/* CAREERS */}
        <div>
          <h3 className="font-semibold mb-3">CAREERS</h3>
          <ul className="space-y-2">
            <li>Careers at Astergo</li>
            <li>Life at Astergo</li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 mt-10 border-t pt-6 flex flex-col lg:flex-row justify-between items-center text-sm gap-6">
        {/* Company Info */}
        <div className="text-center lg:text-left max-w-lg">
          <img
            src="/assets/img/astergo-logo.png"
            alt="Logo"
            className="h-10 mb-2 mx-auto lg:mx-0"
          />
          <p className="text-gray-600">
            Founded in 2022, Astergo Information Technology pvt Limited is a leading end-to-end IT Services and Staffing Solutions provider that transforms businesses and enhances the workforce.
          </p>
        </div>

        {/* Contact Info */}
        <div className="text-center lg:text-right space-y-1"> 
          <p className="font-bold text-sm text-blue-800">
            (+91) 8210345655 / 9163091507
          </p>
          <p className="text-blue-600">info@astergo.info</p>
          {/* Social Icons */}
          <div className="flex justify-center lg:justify-end space-x-3 mt-3 text-white">
            <a href="#" className="bg-red-700 p-2 rounded-full"><FaFacebookF /></a>
            <a href="#" className="bg-red-700 p-2 rounded-full"><FaLinkedinIn /></a>
            <a href="#" className="bg-red-700 p-2 rounded-full"><FaInstagram /></a>
            <a href="#" className="bg-red-700 p-2 rounded-full"><MdEmail /></a>
          </div>
        </div>
      </div>

      {/* Legal */}
      <div className="mt-6 border-t pt-4 text-center text-xs text-gray-500">
        © 2025 Astergo Information Technology pvt Ltd &nbsp; | &nbsp;
        <a href="#" className="hover:underline">Terms of Use</a> &nbsp;|&nbsp;
        <a href="#" className="hover:underline">Privacy Policy</a> &nbsp;|&nbsp;
        <a href="#" className="hover:underline">Cookies</a> &nbsp;|&nbsp;
        <a href="#" className="hover:underline">Sitemap</a>
      </div>
    </footer>
  );
};

export default Footer;
